// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__35EL5","requiredAsterisk":"Info_requiredAsterisk__1BQy5"};